import React, { useEffect, useState } from 'react';
import ParentAccountDetailHeader from '../components/parentAccountDetailHeader';
import {
	changeAccountStatus,
	getParentAccount,
} from '../../../../../../services/settings/accounting';
import PageLoader from '../../../../../../component/PageLoader';
import AccountListTable from '../../components/accountListTable';
import CustomToastMessage from '../../../../../components/customToastMessage';
import CreateAccountsModal from '../../components/createAccountsModal';
import DeleteAccountModel from '../../components/deleteAccountModel';
import checkIcon from '../../../../../../assets/image/check_stock_icon.svg';
import { toast } from 'react-toastify';
import DeactivateAccountReasonModal from '../../components/deactivateAccountReasonModal';
import ActivateAccountModal from '../../components/activateAccountModal';
import { useNavigate } from 'react-router-dom';

export default function ParentAccountDetail({
	parentAccountId,
	type,
	setType,
	setParentAccountId,
}) {
	const [parentAccountDetails, setParentAccountDetails] = useState(null);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [accountList, setAccountList] = useState([]);
	const [accountId, setAccountId] = useState(null);
	const [loader, setLoader] = useState(false);
	const [isShowToast, setShowToast] = useState(false);
	const [isOpenDeleteAccountModal, setIsOpenDeleteAccountModal] = useState(false);
	const [isOpenDeactivateConfirmAccountModal, setIsOpenDeactivateConfirmAccountModal] =
		useState(false);
	const [isOpenActivateAccountModal, setIsOpenActivateAccountModal] = useState(false);
	const [isOpenAccountsModal, setIsOpenAccountsModal] = useState(false);

	const getParentAccountDetail = async () => {
		try {
			setLoader(true);
			const data = await getParentAccount(parentAccountId);
			setParentAccountDetails(data);
			const list = mappedTableData(data.sub_accounts);
			setAccountList(list);
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.account_id,
				account_name: ele.account_name || 'N/A',
				account_code: ele?.account_code || 'N/A',
				account_type: ele?.account_type || 'N/A',
				category: ele?.category || 'N/A',
				description: ele?.description || '',
				source: ele?.source || '',
				status: ele?.status,
			};
		});
	}

	const columns = [
		{ key: 'account_name', label: 'ACCOUNT NAME' },
		{ key: 'account_code', label: 'ACCOUNT CODE' },
		{ key: 'account_type', label: 'ACCOUNT TYPE' },
		{ key: 'category', label: 'CATEGORY' },
		{ key: 'description', label: 'USED FOR' },
		{ key: 'status', label: 'STATUS' },
		{ key: 'source', label: 'SOURCE' },
		{ key: 'action', label: 'ACTION' },
	];

	const handleDeactivateAccount = async (id) => {
		try {
			const body = {
				status: 0,
			};
			const res = await changeAccountStatus(id, body);
			if (res.success) {
				toast.success(res.message);
				setIsOpenDeactivateConfirmAccountModal(false);
				getParentAccountDetail();
			} else {
				toast.error(res.message || 'something went wrong!');
			}
		} catch (err) {
			toast.error(err.message || 'Something went wrong!');
		}
	};
	const onRowClick = (id) => {
		navigate(`/user/${suburl}/settings/accounts`, { state: { id: id } });
	};

	useEffect(() => {
		if (parentAccountId) {
			getParentAccountDetail();
		}
	}, [parentAccountId]);

	const showMessage = () => {
		setShowToast(true);

		setTimeout(() => {
			setShowToast(false);
		}, 3000); // auto hide after 3 sec
	};

	return loader ? (
		<PageLoader />
	) : (
		parentAccountDetails && (
			<div>
				<ParentAccountDetailHeader
					setType={setType}
					setParentAccountId={setParentAccountId}
					accountName={parentAccountDetails?.account_name || ''}
				/>
				{accountList && accountList.length > 0 ? (
					<div className="productTable-body">
						<AccountListTable
							className={'parent-account-detail-table-container'}
							columns={columns}
							accountType={'accounts-list'}
							row={accountList}
							sortDataList={() => {}}
							onRowClick={onRowClick}
							setAccountId={setAccountId}
							sortDirection={() => {}}
							setIsOpenAccountsModal={setIsOpenAccountsModal}
							setIsOpenDeactivateConfirmAccountModal={setIsOpenDeactivateConfirmAccountModal}
							setIsOpenDeleteModal={setIsOpenDeleteAccountModal}
							setIsOpenActivateAccountModal={setIsOpenActivateAccountModal}
						/>
					</div>
				) : (
					<div className="text-center py-5">
						<div className="fs-4 font-medium text-dark">{'No Related Accounts Found'}</div>
						<div className="fs-5 font-small text-dark">
							{'This parent account does not have any linked accounts yet.'}
						</div>
					</div>
				)}
				{isOpenAccountsModal && (
					<CreateAccountsModal
						showMessage={showMessage}
						setSelectedId={setAccountId}
						selectedId={accountId}
						isOpenModal={isOpenAccountsModal}
						setIsOpenModal={setIsOpenAccountsModal}
						getList={getParentAccountDetail}
					/>
				)}

				{isShowToast && (
					<CustomToastMessage
						icon={checkIcon}
						title={accountId ? 'Account updated successfully' : 'Account created successfully'}
						description={
							accountId
								? 'All changes have been saved and are now reflected in the system.'
								: 'Your account has been created. You can now use it to record and track transactions.'
						}
					/>
				)}

				{isOpenDeleteAccountModal && (
					<DeleteAccountModel
						isOpenModal={isOpenDeleteAccountModal}
						setIsOpenModal={setIsOpenDeleteAccountModal}
						accountId={accountId}
						getList={getParentAccountDetail}
					/>
				)}
				{isOpenActivateAccountModal && (
					<ActivateAccountModal
						accountId={accountId}
						isOpenModal={isOpenActivateAccountModal}
						setIsOpenModal={setIsOpenActivateAccountModal}
						getAccountDetails={getParentAccountDetail}
					/>
				)}

				{isOpenDeactivateConfirmAccountModal && (
					<DeactivateAccountReasonModal
						isOpenModal={isOpenDeactivateConfirmAccountModal}
						setIsOpenModal={setIsOpenDeactivateConfirmAccountModal}
						accountId={accountId}
						getAccountDetails={getParentAccountDetail}
					/>
				)}
			</div>
		)
	);
}
